import { Status } from 'app/shared/model/enumerations/status.model';

export interface IParSchoolLevel {
  id?: number;
  code?: string;
  name?: string;
  nameAr?: string;
  nameEn?: string;
  type?: string;
  status?: Status;
}

export const defaultValue: Readonly<IParSchoolLevel> = {};
